export const messages = {
  en: {
    aOrderDetail: {
      title: 'Order Details',
      orderId: 'Order ID',
      totalAmount: 'Total Amount',
      orderTime: 'Order Time',
      user: 'User',
      profitSharing: 'Profit Sharing',
      yes: 'Yes',
      no: 'No',
      platform: 'Platform',
      products: 'Products',
      fees: 'Fees',
      ledgers: 'Ledgers',
      consignee: 'Consignee',
      operations: 'Operations',
      discounts: 'Discounts'
    },
    aOrderDetailCarts: {
      productName: 'Product Name',
      productId: 'Product ID',
      quantity: 'Quantity',
      paymentAmount: 'Payment Amount',
      status: 'Status',
      paymentTime: 'Payment Time'
    },
    aOrderDetailFee: {
      serial: 'No.',
      feeName: 'Fee Name',
      amount: 'Amount',
      paymentAmount: 'Payment Amount',
      paymentMethod: 'Payment Method',
      status: 'Status',
      unpaid: 'Unpaid',
      paid: 'Paid',
      paymentTime: 'Payment Time'
    },
    aOrderDetailLedgers: {
      merchant: 'Merchant',
      specification: 'Specification',
      ledgerAmount: 'Ledger Amount',
      recharge: 'Recharge',
      objectId: 'Object ID',
      serviceFee: 'Service Fee',
      discount: 'Discount',
      productFee: 'Product Fee',
      unknown: 'Unknown',
      accountRecharge: 'Account Recharge',
      coupon: 'Coupon'
    },
    aOrderDetailAddress: {
      userName: 'User Name',
      phone: 'Phone',
      shippingAddress: 'Shipping Address',
      remark: 'Remark'
    },
    aOrderDetailEvent: {
      serial: 'No.',
      operationTime: 'Operation Time',
      description: 'Description'
    },
    aOrderDetailDiscounts: {
      serial: 'No.',
      discountType: 'Discount Type',
      discountAmount: 'Discount Amount',
      description: 'Description',
      time: 'Time'
    }
  },
  zh: {
    aOrderDetail: {
      title: '订单详情',
      orderId: '订单编码',
      totalAmount: '总金额',
      orderTime: '下单时间',
      user: '用户',
      profitSharing: '是否分账',
      yes: '是',
      no: '否',
      platform: '平台',
      products: '商品',
      fees: '费用',
      ledgers: '分账',
      consignee: '收货人',
      operations: '操作信息',
      discounts: '订单优惠'
    },
    aOrderDetailCarts: {
      productName: '商品名称',
      productId: '商品编号',
      quantity: '数量',
      paymentAmount: '支付金额',
      status: '状态',
      paymentTime: '支付时间'
    },
    aOrderDetailFee: {
      serial: '序号',
      feeName: '费用名称',
      amount: '金额',
      paymentAmount: '支付金额',
      paymentMethod: '支付方式',
      status: '状态',
      unpaid: '未支付',
      paid: '已支付',
      paymentTime: '支付时间'
    },
    aOrderDetailLedgers: {
      merchant: '商户',
      specification: '规格',
      ledgerAmount: '分账金额',
      recharge: '充值',
      objectId: '对象编号',
      serviceFee: '服务费',
      discount: '折扣金',
      productFee: '商品金',
      unknown: '未知',
      accountRecharge: '账户充值',
      coupon: '优惠券'
    },
    aOrderDetailAddress: {
      userName: '用户名称',
      phone: '手机号码',
      shippingAddress: '收货地址',
      remark: '备注'
    },
    aOrderDetailEvent: {
      serial: '序号',
      operationTime: '操作时间',
      description: '说明'
    },
    aOrderDetailDiscounts: {
      serial: '序号',
      discountType: '优惠方式',
      discountAmount: '优惠金额',
      description: '说明',
      time: '时间'
    }
  }
}